import React from 'react';
import { motion } from 'framer-motion';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { glassStyles } from '../utils/glassStyles';

const NextArrow = ({ onClick }) => (
  <motion.button
    onClick={onClick}
    className="absolute right-[-4rem] top-1/2 -translate-y-1/2 z-10 p-3 rounded-full hover:bg-white/20 transition-all duration-300 focus:outline-none"
    style={glassStyles.button}
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.9 }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-akasha-brown" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </svg>
  </motion.button>
);

const PrevArrow = ({ onClick }) => (
  <motion.button
    onClick={onClick}
    className="absolute left-[-4rem] top-1/2 -translate-y-1/2 z-10 p-3 rounded-full hover:bg-white/20 transition-all duration-300 focus:outline-none"
    style={glassStyles.button}
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.9 }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-akasha-brown" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
    </svg>
  </motion.button>
);

const ProductCarousel = ({ products, title }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    dotsClass: "slick-dots custom-dots",
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <section className="relative py-16 overflow-hidden bg-transparent">
      {/* Stone texture background */}
      {/* <div 
        className="absolute inset-0 bg-cover bg-center z-0"
        style={{ backgroundImage: 'url("/assets/stonebgr1.jpg")' }}
      /> */}
      {/* Dark overlay for better contrast */}
      {/* <div className="absolute inset-0 bg-black/40 z-0" /> */}
      
      <div className="relative z-10 container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-cursive text-akasha-brown text-center mb-6 md:mb-10">
          {title}
        </h2>
        
        <div className="relative px-12">
          <Slider {...settings}>
            {products.map((product, index) => (
              <div key={product.id} className="px-2">
                <motion.div 
                  className="overflow-hidden rounded-[2rem]"
                  style={glassStyles.dynamic.initial}
                  whileHover={glassStyles.dynamic.hover}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                >
                  <div className="relative pb-[100%]">
                    {product.image ? (
                      <img 
                        src={product.image} 
                        alt={product.name}
                        className="absolute inset-0 w-full h-full object-cover"
                      />
                    ) : (
                      <div className="absolute inset-0 w-full h-full bg-akasha-beige/20 flex items-center justify-center">
                        <span className="text-akasha-brown">Sin imagen</span>
                      </div>
                    )}
                  </div>
                  <div className="p-4">
                    <h3 className="text-lg font-medium text-akasha-black truncate">{product.name}</h3>
                    {product.material && <p className="text-sm text-gray-700 mt-1 truncate">{product.material}</p>}
                    <div className="mt-4 flex justify-between items-center">
                      {(typeof product.price === 'number') && <span className="text-akasha-brown font-bold">${product.price.toLocaleString()}</span>}
                      <motion.a 
                        href={`/product/${product.id}`}
                        className="text-akasha-brown px-4 py-2 rounded-full border border-akasha-brown hover:bg-akasha-brown hover:text-white"
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                      >
                        Ver detalles
                      </motion.a>
                    </div>
                  </div>
                </motion.div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default ProductCarousel;
